<template>
  <div>
    <div class="hidden help-title">Cross Tabulation Information</div>
    <p>
      <strong>What is cross tabulation?</strong><br />
      {{ descriptions.crossTabulation }}
    </p>

    <p>
      <strong>What is a table?</strong><br />
      A table (or tables) is the resulting display of cross tabulation, where
      each cell of the table contains frequencies and percentages.
    </p>

    <p>
      <strong>What are frequencies?</strong><br />
      Frequencies are counts, or percentages derived from counts. In the BRFSS,
      frequencies represent numbers of persons reporting certain health
      behaviors or demographic characteristics. You can produce frequencies on a
      single variable by selecting it as your row variable. The output is also
      called a one-way frequency table.
    </p>

    <p>
      <strong>What is logistic regression?</strong><br />
      {{ descriptions.logisticRegression }}
    </p>

    <p>
      <strong>What is a dependent variable?</strong><br />
      A dependent variable is something affected by one or more independent
      variables. For example, general health is known to be affected by age;
      therefore, health may be a dependent variable in some analyses.
    </p>

    <p>
      <strong>What is an independent variable?</strong><br />
      An independent variable is something that affects a dependent variable.
      For example, age is known to affect general health; therefore, age may be
      an independent variable in some analyses.
    </p>

    <p>
      <strong>What is a control variable?</strong><br />
      A control variable is a factor that helps refine cross tabulations by
      splitting data into separate tables.
    </p>

    <p>
      <strong>What BRFSS data are available for analysis?</strong><br />
      At this time, the WEAT database contains BRFSS data up to 2017. More data
      sets may be added in the future.
    </p>

    <p>
      <strong>What does sample size tell me?</strong><br />
      Sample size reports the number of individuals with the conditions
      specified in each cell of a table.
    </p>

    <p>
      <strong>What does the weighted sample size represent?</strong><br />
      The weighted sample size uses data from the sample of respondents and
      represents an estimate of the number of adults in the US population with
      the conditions specified in a table.
    </p>

    <p>
      <strong>What does cell percentage tell me?</strong><br />
      The cell percentage reports the proportion of individuals matching
      conditions depicted in each cell of a table.
    </p>

    <p>
      <strong>What does the row percentage tell me?</strong><br />
      The row percentage that appears in each cell of a table reports the
      proportion of individuals with that condition. When row percentages are
      added across the columns, they will total 100%. This gives you the
      distribution of individuals with that condition across the "outcome"
      variable.
    </p>

    <p>
      <strong>What does the column percentage tell me?</strong><br />
      The column percentage that appears in each cell of a table reports the
      proportion of individuals with that row's value. When rows are added down
      the columns, they will total 100%.
    </p>

    <p>
      <strong>What does "Total Number Missing" value mean?</strong><br />
      The total number missing represents the number of "cases" or respondents
      missing answers to one or more variables. For example, if 10 individuals
      did not report educational attainment, and another 20 did not report
      diabetes status, and yet another 3 reported neither diabetes status nor
      educational attainment, then a cross tabulation of Education x Diabetes
      would have 23 missing cases.
    </p>

    <p>
      <strong>What is a standard error?</strong><br />
      A standard error is the estimated standard deviation of a population
      estimate. In the WEAT, standard errors are calculated appropriately for
      the complex survey design of the BRFSS.
    </p>
  </div>
</template>

<script>
import current from "@/scripts/current";
import descriptions from "@/scripts/descriptions";

export default {
  computed: {
    descriptions: () => descriptions,
  },
  data: function () {
    current.initializeDataAnalysisFaq();
    return {};
  },
  methods: {},
};
</script>

<style scoped>
</style>
